import axios from "axios";

const $host = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL + "/api",
});

const $authHost = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL + "/api",
});

$authHost.interceptors.request.use((config) => {
  const accessToken = process.env.REACT_APP_SECRET_ACCESS_TOKEN;
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  if (accessToken) {
    config.headers.Authorization = accessToken;
    config.headers.SecretKey = secretKey;
  }

  config.withCredentials = true;
  config.credentials = "include"; // Это для явного указания передачи куков
  return config;
});

// let retryCount = 0;
// $authHost.interceptors.response.use(
//   (config) => config,
//   async (error) => {
//     if (error.response.status === 403 && error.config && !retryCount) {
//       const originalRequest = error.config;
//       retryCount = 1;

//       try {
//         await userApi.refreshTokens();
//         return await $authHost.request(originalRequest);
//       } catch (err) {
//         showStandartNotification(
//           err.message || "Для этой операции нужно зарегистрироваться",
//           notificationTimeouts.short,
//           notificationTypes.reject
//         );
//         throw err;
//       }
//     }

//     throw error;
//   }
// );

export { $host, $authHost };
